export const NOTE_TYPES = [
  { value: "SIMPLE_NOTE", label: "Nota semplice" },
  { value: "DISEASE_REPORT", label: "Segnalazione malattia" },
];

export const FIELD_NOTE_OPERATION_TYPES = {
  CREATE: "create",
  UPDATE: "update",
  DELETE: "delete",
};

export const FIELD_NOTE_MESSAGES = {
  [FIELD_NOTE_OPERATION_TYPES.CREATE]: "Nota aggiunta con successo",
  [FIELD_NOTE_OPERATION_TYPES.UPDATE]: "Nota aggiornata con successo",
  [FIELD_NOTE_OPERATION_TYPES.DELETE]: "Nota eliminata con successo",
};
